export default "__VITE_ASSET__46cea8d2__"